export enum ViewMode {
  List = 'list',
  list = 'list',
  cards = 'grid',
  Grid = 'grid',
  grid = 'grid',
  rows = 'list',
}
